var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 896 896",
    style: {
      enableBackground: "new 0 0 896 896"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M685.4,1H211.6C95.1,1,1,95.1,1,211.6v473.7C1,801.5,95.1,896,211.6,896h473.7C801.5,896,896,801.9,896,685.4 V211.6C896,95.1,801.5,1,685.4,1z M758.2,383.1c-57.4,2.9-114.1-13.7-161.1-46.2c-0.4,6.7-0.8,11.7-0.8,16.7 c0,62.9,0.4,126.1,0,189c2.5,67.9-19.6,134.5-62.4,187.3c-35,42.9-85.3,70.8-140.3,77.4c-2.1,0.4-4.6,1.2-6.7,2.5h-40.4 c-1.7-0.8-3.3-1.2-5.4-2.1c-84.1-11.2-153.6-72-175.3-154c-5-17.5-8.7-35.4-11.2-53.3v-35c3.3-19.1,7.5-37.9,12.9-56.2 c26.6-77,94.1-132.8,174.4-144.4c18.3-3.7,37-5,57.4-7.9c0,39.5,0.4,76.2-0.4,112.8c0,2.9-6.7,6.7-10.8,8.3 c-20.4,6.2-41.2,10.4-60.8,18.3c-39.1,13.3-64.1,52-59.9,93.2c1.7,45.4,32.5,84.9,76.2,97.4c52,17.5,108.2-10.4,125.3-62.4 c2.1-6.7,3.7-13.3,4.6-20.4c4.2-20.4,5.8-41.2,5.8-62c0-142.8-0.8-285.2-1.2-427.9c0-2.5,0.4-4.6,0.8-7.9h114.9 c12.9,95.3,62,156.5,164.4,165.3L758.2,383.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.59b99b38be99f87ab531872df784a218.svg";
export { ForwardRef as ReactComponent };